import React, { Suspense } from "react";
import { connect } from "react-redux";

import LoadingIndicator from "react-loading-indicator";
import { LoadingOverlay } from "./style/Misc";

import grommetTheme from "./shared/grommetTheme";

import { Grommet } from "grommet";
import AppSettings from "./AppSettings";
import styled from "styled-components";

function getLazyPage(page) {
  return React.lazy(() => import(`./pages/${page}/index.js`));
}

const DynamicPage = ({ page }) => {
  const Control = getLazyPage(page);
  return <Control />;
};

const LoadingControl = () => (
  <LoadingOverlay>
    <LoadingIndicator />
  </LoadingOverlay>
);

const StyledApp = styled.div`
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
  }
`;

function App(props) {
  return (
    <StyledApp>
      <AppSettings page={props.app} />
      <Suspense fallback={<LoadingControl />}>
        <Grommet theme={grommetTheme}>
          <div style={{ position: "relative" }}>
            <DynamicPage page={props.app || "none"} />

            {props.loading ? <LoadingControl /> : null}
          </div>
        </Grommet>
      </Suspense>
    </StyledApp>
  );
}

const mapStateToProps = (state) => ({
  loading: state.loading.loading,
  app: state.app,
});

export default connect(mapStateToProps)(App);
